import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { Router } from "@angular/router";
import { currentUrlType } from "@assoanalytics/app/core/models/current-url";
import { CoreService } from "@assoanalytics/app/core/services/core.service";
import { LoginService } from "@assoanalytics/app/core/services/login.service";
import { NavService } from "@assoanalytics/app/core/services/nav.service";
import { TranslateModule } from "@ngx-translate/core";
import { first } from "rxjs";

@Component({
  selector: "app-loading",
  templateUrl: "./loading.component.html",
  styleUrls: ["./loading.component.scss"],
  imports: [TranslateModule, MatProgressBarModule],
})
export class LoadingComponent implements OnInit {
  @Input() type: string = "loading";
  @Output() refreshResult = new EventEmitter<boolean>();

  options = this.settings.getOptions();
  logo = this.options.loginLogo;
  logoSize = this.options.loginLogoSize;
  redirectUrl: currentUrlType = { url: "" };

  constructor(
    private settings: CoreService,
    private loginService: LoginService,
    private navService: NavService,
    private router: Router,
  ) {
    this.navService.redirectUrl.pipe(first()).subscribe((url) => {
      this.redirectUrl = url;
    });
  }

  async ngOnInit() {
    const result = await this.loginService.refreshTokenAndLoginActions(
      this.redirectUrl,
    );

    this.refreshResult.emit(result);

    if (!result) {
      this.router.navigate(["/login"]);
    }
  }
}
